import { render, staticRenderFns } from "./ActivitySwitch.vue?vue&type=template&id=42176c8f&scoped=true"
import script from "./ActivitySwitch.vue?vue&type=script&lang=js"
export * from "./ActivitySwitch.vue?vue&type=script&lang=js"
import style0 from "./ActivitySwitch.vue?vue&type=style&index=0&id=42176c8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42176c8f",
  null
  
)

export default component.exports